<template>
  <div>
    <div v-if="!loading">
      <country-header
        @changeSelectCountry="changeSelectCountry"
        v-if="countryInfo"
      ></country-header>
      <country-filter
        v-if="countryInfo"
        :country-info="countryInfo"
        :province_code.sync="params.province_code"
        :visa_type.sync="params.visa_type"
      ></country-filter>

      <product-list :product-list="productList"></product-list>
    </div>

    <div class="loading" v-else>
      <van-loading color="#1989fa" />
    </div>
  </div>
</template>

<script>
import utils from '@/services/tools';
import CountryHeader from './components/country-header';
import CountryFilter from './components/country-filter/country-filter';
import ProductList from './components/product-list/product-list';
import workWxCommonService from '../services/work-wx-common-service.js';
import countryApiService from './services/country-api-service.js';

export default {
  components: {
    CountryHeader,
    CountryFilter,
    ProductList,
  },
  data() {
    return {
      loading: true,
      params: {
        visa_country_id: 10017, // 当前选中的国家ID, 默认选中澳大利亚
        province_code: 440000, // 默认选中广东
        visa_type: '',
      },
      countryInfo: undefined,
      productList: [],
    };
  },
  created() {
    this.init();
  },
  computed: {
    watchParams() {
      return {
        ...this.params,
        visa_country_id: undefined,
      };
    },
  },
  watch: {
    // 参数变化，重新请求商品列表
    watchParams: {
      handler() {
        if (!this.loading) {
          console.log('触发参数变化');
          this.getProductList();
        }
      },
      deep: true,
    },
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        await workWxCommonService.commonLogin();
        await this.getCountryInfo();
        await this.getProductList();
        this.loading = false;
      } catch (e) {
        utils.showError(e);
        this.loading = false;
      }
    },
    async getCountryInfo() {
      try {
        const res = await countryApiService.getCountryInfo({
          visa_country_id: this.params.visa_country_id,
          province_code: this.params.province_code,
        });
        this.countryInfo = res;
        // 初始化选中签证类型
        if (
          !this.params.visa_type ||
          this.countryInfo.visa_type_list.indexOf(this.params.visa_type) === -1
        ) {
          this.params.visa_type = this.countryInfo.visa_type_list[0];
        }
      } catch (e) {
        return Promise.reject(e);
      }
    },
    // 获取商品列表
    async getProductList() {
      try {
        if (!this.params.visa_type) return; // 不会终止下面的await
        this.productList = [];
        const params = {
          visa_country_id: this.params.visa_country_id,
          province_code: this.params.province_code,
          visa_type: this.params.visa_type,
        };
        const res = await countryApiService.getProductList(params);
        this.productList = res.product_list;
      } catch (e) {
        const err = { msg: e && e.msg ? e.msg : '加载数据失败' };
        return Promise.reject(err);
      }
    },
    changeSelectCountry(id) {
      this.params.visa_country_id = id;
      this.init();
    },
  },
};
</script>

<style lang="less" scoped>
.loading {
  width: 100%;
  padding-top: 100px;
  background: #f5f6f7;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #918f8f;
  text-align: center;
}
</style>
